@if (isLoading$ | async) {
  <app-mini-content-loader></app-mini-content-loader>
} @else {
  <div class="place-selector-container flex-row justify-start align-center"
    *ngrxLet="restaurant$ as restaurant"
    (click)="!isReadOnly && onPlaceSectionClick()"
    [class.disabled]="isReadOnly">
    <mat-icon svgIcon="map-marker"
    [color]="isReadOnly ? 'accent' : iconColor"></mat-icon>
    @if (restaurant) {
      <span> {{ restaurant.name }} </span>
      @if (!isReadOnly) {
        <mat-icon class="delivery-icon"
        >keyboard_arrow_down</mat-icon>
      }
    } @else {
      {{ "COMMON.RESTAURANT" | transloco }}
    }
  </div>
}
